import React from "react";
import { TSDIGITAL_PORTALE_PUBLIC_URL } from "../../config.js";
import { Alert } from "antd";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils.js";

const MessageEmptyCompaniesStudio = props => {
  const studioFind = GetSelectedCompanyStudio();
  return props.myType === "STUDIO" ? (
    <div className="emptyCompanies container">
      <h2>
        {studioFind?.taxRegion !== "ES" ? "Non hai ancora abilitato nessun cliente" : "Aún no has habilitado ningún cliente"} <br /> {studioFind?.taxRegion !== "ES" ? "all'uso di TeamSystem Digital Box" : "para el uso de TeamSystem Digital Box"}{" "}
      </h2>
      {studioFind?.taxRegion !== "ES" && <div className="buttonContainer">
        <div className="button primary">
          <div>
            <a
              href={TSDIGITAL_PORTALE_PUBLIC_URL}
              id="goToAgyo"
              aria-label={"Link al portale Agyo per le configurazioni"}
              tabIndex="0"
            >
              VAI ALLA CONFIGURAZIONE SU PORTALE TS
            </a>
          </div>
        </div>
        <div className="button">
          <div>
            <span data-elevio-inline={"273"} data-elevio-style="nothing">
              GUARDA IL TUTORIAL
            </span>
          </div>
        </div>
      </div>}
    </div>
  ) : (
    <Alert
      message={""}
      description="Si è verificato un errore. Il servizio DigitalBox non risulta attivo"
      type="error"
      showIcon
      style={{ marginTop: "60px" }}
    />
  );
};
export default MessageEmptyCompaniesStudio;
